"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreMatchMedia = require("@legacy-vfuk/core-match-media");

var _coreAnimate = _interopRequireDefault(require("@legacy-vfuk/core-animate"));

var _coreOverlay = _interopRequireDefault(require("@legacy-vfuk/core-overlay"));

var _getElementHeight = _interopRequireDefault(require("./hooks/getElementHeight"));

var _setFocus = _interopRequireDefault(require("./hooks/setFocus"));

var _overlayClickHandler = _interopRequireDefault(require("./helpers/overlayClickHandler"));

var Styled = _interopRequireWildcard(require("./styles/TopNavigation.style"));

var _MainBar = _interopRequireDefault(require("./components/MainBar"));

var _TopBar = _interopRequireDefault(require("./components/TopBar"));

var _SideNavigation = _interopRequireDefault(require("./components/SideNavigation"));

var _SkipLink = _interopRequireDefault(require("./components/SkipLink"));

var _TopNavigationContext = _interopRequireDefault(require("./context/TopNavigationContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TopNavigation = function TopNavigation(_ref) {
  var topNav = _ref.topNav,
      logo = _ref.logo,
      primaryNav = _ref.primaryNav,
      mobileNavTrigger = _ref.mobileNavTrigger,
      secondaryNav = _ref.secondaryNav,
      sideNavigationCloseButton = _ref.sideNavigationCloseButton,
      skipLink = _ref.skipLink,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 1 : _ref$zIndex,
      onInteraction = _ref.onInteraction,
      _ref$dataAttributePre = _ref.dataAttributePrefix,
      dataAttributePrefix = _ref$dataAttributePre === void 0 ? '' : _ref$dataAttributePre;
  var topNavigation = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showSearch = _useState2[0],
      setShowSearch = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isTransitioning = _useState4[0],
      setIsTransitioning = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      navLevel = _useState6[0],
      setNavLevel = _useState6[1]; // Note: activeNav is the navigation that appears
  //       in the first level of side navigation


  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      activeNav = _useState8[0],
      setActiveNav = _useState8[1]; // Note: activeSubNav is the navigation that appears
  //       in the second level of side navigation


  var _useState9 = (0, _react.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      activeSubNav = _useState10[0],
      setActiveSubNav = _useState10[1]; // Note: navTree allows us to keep a history of activeSubNavs
  //       as the subNav changes


  var _useState11 = (0, _react.useState)(),
      _useState12 = _slicedToArray(_useState11, 2),
      navTree = _useState12[0],
      setNavTree = _useState12[1];

  var _useBreakpoints = (0, _coreMatchMedia.useBreakpoints)(),
      lgAndAbove = _useBreakpoints.lgAndAbove;

  var topNavHeight = (0, _getElementHeight["default"])(topNavigation);
  var animationDuration = 400;
  (0, _setFocus["default"])(logo, navLevel, setNavLevel, showSearch, setShowSearch, activeNav, activeSubNav, sideNavigationCloseButton, navTree, setNavTree, setIsTransitioning, setActiveSubNav, animationDuration, secondaryNav);

  var interactionHandler = function interactionHandler(event, trigger) {
    if (!onInteraction) return;
    onInteraction(event, trigger);
  };

  return /*#__PURE__*/_react["default"].createElement(_TopNavigationContext["default"].Provider, {
    value: {
      zIndex: zIndex,
      topNav: topNav,
      logo: logo,
      primaryNav: primaryNav,
      mobileNavTrigger: mobileNavTrigger,
      secondaryNav: secondaryNav,
      showSearch: showSearch,
      setShowSearch: setShowSearch,
      navLevel: navLevel,
      setNavLevel: setNavLevel,
      activeNav: activeNav,
      setActiveNav: setActiveNav,
      activeSubNav: activeSubNav,
      setActiveSubNav: setActiveSubNav,
      topNavHeight: topNavHeight,
      animationDuration: animationDuration,
      sideNavigationCloseButton: sideNavigationCloseButton,
      navTree: navTree,
      setNavTree: setNavTree,
      isTransitioning: isTransitioning,
      setIsTransitioning: setIsTransitioning,
      interactionHandler: interactionHandler,
      dataAttributePrefix: dataAttributePrefix
    }
  }, /*#__PURE__*/_react["default"].createElement(Styled.TopNavigation, {
    ref: topNavigation,
    zIndex: zIndex
  }, /*#__PURE__*/_react["default"].createElement(_SkipLink["default"], {
    text: skipLink.text,
    skipLinkId: skipLink.skipLinkId
  }), lgAndAbove ? /*#__PURE__*/_react["default"].createElement(_TopBar["default"], null) : null, /*#__PURE__*/_react["default"].createElement(_MainBar["default"], null)), /*#__PURE__*/_react["default"].createElement(_coreAnimate["default"], {
    show: navLevel > 0,
    enter: {
      animations: ['slideFromLeft'],
      duration: animationDuration
    },
    exit: {
      animations: ['slideToLeft'],
      duration: animationDuration
    }
  }, /*#__PURE__*/_react["default"].createElement(_SideNavigation["default"], null)), /*#__PURE__*/_react["default"].createElement(_coreAnimate["default"], {
    show: navLevel > 0 || showSearch,
    enter: {
      animations: ['fadeIn'],
      duration: animationDuration
    },
    exit: {
      animations: ['fadeOut'],
      duration: animationDuration
    }
  }, /*#__PURE__*/_react["default"].createElement(_coreOverlay["default"], {
    show: true,
    onClick: function onClick() {
      return (0, _overlayClickHandler["default"])(logo, setShowSearch, setNavLevel);
    },
    position: "fixed",
    zIndex: zIndex - 1
  })));
};

TopNavigation.displayName = "TopNavigation";
var _default = TopNavigation;
exports["default"] = _default;
//# sourceMappingURL=TopNavigation.js.map